import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { paths } from '@app/constants';
import { TouchService } from '@app/core/services/touch/touch.service';

export interface DownloadOptionsComponentData {
  chartEntitlementIds: string[];
  hideMergeChargeMessage: boolean;
}

@Component({
  selector: 'app-download-options',
  templateUrl: './download-options.component.html',
  styleUrls: ['./download-options.component.scss']
})
export class DownloadOptionsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DownloadOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadOptionsComponentData,
    private router: Router,
    public touchService: TouchService,
  ) {}

  ngOnInit() {
  }

  toUpgrade(event) {
    event.preventDefault();
    const { chartEntitlementIds } = this.data;
    this.router.navigate([paths.CHARTS_MANAGER, paths.UPGRADE_CHARTS, 'id'], {
      queryParams: {
        chartEntitlementIds: JSON.stringify(chartEntitlementIds)
      }
    });
    this.dialogRef.close();
  }
}
